module.exports = __webpack_public_path__ + "static/media/006.818ddc14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/normals/006.jpg
// module id = 479
// module chunks = 0